import React from 'react';
import { DialogActions } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => {
  return {
    actions: {
      '& > *': {
        margin: 0,
        marginLeft: 8
      }
    }
  };
});

export const ModalActions: React.FC<any> = ({ children }) => {
  const classes = useStyles();
  return <DialogActions className={classes.actions}>{children}</DialogActions>;
};
